<template>
  <span
    v-if="
      (!label && labeled && isRestrict && $store.state.auth.user.token) ||
      (!label && !labeled && isRestrict && $store.state.auth.user.token)
    "
  >
    <v-icon size="10px" color="grey darken-0" style="margin-bottom: 2px"
      >mdi-lock</v-icon
    >
  </span>
</template>

<script>
export default {
  props: ["label", "labeled", "isRestrict"],
};
</script>

<style scoped></style>
